/**
 * Reading an invitation out of the URL.
 *
 * Pure, and separate from the component, because the authenticator makes two decisions from it before any
 * route has matched or anyone is signed in — which form to open on, and what to prefill — and both were
 * wrong in ways nobody could see. An invitee was shown the SIGN-IN form and asked for a password that had
 * never been issued, with no way forward.
 *
 * The address travels in the link because there is nobody to ask for it at that point: no session, no
 * account, no API call we are allowed to make. It is the address the invitation was delivered to, so it
 * tells its reader nothing they did not already know.
 */

export interface Invitation {
  token: string;
  /** Empty for invitations sent before the address was added to the link — those still work, unprefilled. */
  email: string;
}

export function readInvitation(pathname: string, search: string): Invitation | null {
  if (!pathname.endsWith('/accept-invite')) return null;
  const q = new URLSearchParams(search);
  const token = q.get('token');
  // A token is what makes it an invitation. Without one there is nothing to accept, so this is an ordinary
  // visit to the page and the ordinary sign-in form is the right thing to show.
  if (!token) return null;
  return { token, email: (q.get('email') ?? '').trim() };
}
